<template>
  <kambly-form inline-template>
    <div class="form">
      <form class="form__form" method="POST"
            v-bind:action="endpoint"
            ref="form">

        <div class="form__row">
          <div class="row">
            <div class="col-md-6">
              <dropdown name="gender"
                        :label="content.formLabels.gender"
                        :select-label="content.formLabels.pleaseSelect"
                        :options="content.formLabels.genderOptions"></dropdown>
            </div>
          </div>
        </div>

        <div class="form__row">
          <div class="row">
            <div class="col-md-6">
              <form-field :label="content.formLabels.lastname" name="name"
                          type="text"
                          validation="required"></form-field>
            </div>
            <div class="col-md-6">
              <form-field :label="content.formLabels.name" name="firstname"
                          type="text" validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-field :label="content.formLabels.street" name="street"
                          type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-4">
              <form-field :label="content.formLabels.zip"
                          name="postalcode"
                          type="text"
                          :validation="'required|plz-' + contestCountry">
              </form-field>
            </div>
            <div class="col-md-8">
              <form-field :label="content.formLabels.city" name="city" type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-field label="E-Mail" name="email" type="email"
                          validation="email|required"></form-field>
            </div>
          </div>
        </div>
        <div class="form__row">
          <div class="row">
            <div class="col-12">
              <div class="form__row form__row--small">
                <checkbox name="terms"
                          :label="content.terms"
                          :required="true"></checkbox>
              </div>
            </div>
            <div class="col-12">
              <div class="form__row form__row--small">
                <checkbox name="newsletter"
                          :label="content.newsletter"
                          :required="false"></checkbox>
              </div>
            </div>
            <div class="col-12">
              <div class="form__row form__row--small">
                <div class="checkbox__label checkbox__label--legal" v-html="content.legalData"></div>
              </div>
            </div>
            <div class="col-12 d-md-flex justify-content-end">
              <div class="form__submit">
                <div class="button button--primary" @click.exact="resetAll" @click.prevent="submitForm">{{ content.abortLabel }}</div>
              </div>
              <div class="form__submit">
                <button class="button button--secondary" :class="{'button--loading': loading}" type="submit" :disabled="loading"
                        @click.prevent="submitForm">{{ content.continueLabel}}</button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </kambly-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'content'
    ])
  }
}
</script>